<template>
  <v-dialog v-model="modelFamily" width="700px" v-on:update:modelValue="fechar" scrollable>
    <v-btn icon="mdi-close" size="x-small" class="btn-close" @click="fechar"></v-btn>
    <v-card>
      <v-card-title class="pa-0 shadow-bottom">
        <v-row class="ma-0">
          <v-col cols="12" class="py-4 bg-color-1 text-color-white text-center">
            <b>Escolha qual deseja comprar</b>
          </v-col>
          <v-col cols="12" class="py-1 text-small d-flex justify-center">
            <b v-if="produto.offer.offer_connect > 0 && (produto.offer.is_offer_unlimited == 1 || produto.offer.amount_connect > totalFamily)">
              <span v-if="produto.offer.is_offer_club == 1">Preço Clube</span><span v-else>Ative e Pague</span> {{ $formatNumber(produto.offer.offer_connect, {style: 'currency', currency: 'BRL'}) }} por unidade <span v-if="produto.offer.amount_connect > 0">(Limite {{ produto.offer.amount_connect }})</span> até {{ $formatDate(produto.offer.offer_finish_date+" 00:00:00") }}
            </b>
            <b v-else-if="produto.offer.offer_connect > 0 && produto.offer.is_offer_unlimited == 0 && produto.offer.amount_connect <= totalFamily">
              Limite atingido. A partir de agora {{ $formatNumber(produto.offer.offer_price, {style: 'currency', currency: 'BRL'}) }} por unidade <span v-if="produto.offer.amount_connect > 0">(Limite {{ produto.offer.amount_connect }})</span> até {{ $formatDate(produto.offer.offer_finish_date+" 00:00:00") }}
            </b>
            <b v-else>Oferta por {{ $formatNumber(produto.offer.offer_price, {style: 'currency', currency: 'BRL'}) }} por unidade até {{ $formatDate(produto.offer.offer_finish_date+" 00:00:00") }}</b>
          </v-col>  
          <v-col cols="12" class="py-0 text-small d-flex justify-center">
            <span class="text-xsmall" v-if="produto.cashback > 0">Cashback {{ $formatNumber(produto.cashback, {style: 'currency', currency: 'BRL'})  }}</span>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text class="pa-0 pt-2" style="height: 80%">
        <ProductFamily v-for="p in getFamily" :key="p.sku" :product="p" :reloadFamily="reloadFamily"></ProductFamily>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import ProductFamily from '@/components/ProductFamily.vue';
import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'DialogFamily',
  components: {
    ProductFamily
  },
  data(){
    return {
      modelFamily: false
    }
  },
  props: {
    produto: {
      type: Object,
      default: null
    },
    model: {
      type: Boolean,
      default: false
    },
    fechar: {
      type: Function,
      default: null
    }
  },
  watch: {
    model() {
      this.modelFamily = this.model;
      if(this.model == true){
        this.getFamily.forEach(element => {
          this.getImageCarousel({ sku: element.sku, imghash: "t-"+element.imghash }).then(function(image){
            element.image = image;
          }.bind(this));
        });
      }
    },
  },
  computed: {
    ...mapGetters('products', {
      getFamily: 'getFamily',
    }),
    ...mapGetters('cart', {
      getTotalFamily: 'getTotalFamily',
    }),
    totalFamily(){
      return this.getTotalFamily(this.produto.offer.offer_id);
    }
  },
  methods: {
    ...mapActions('products', {
      loadFamily: 'loadFamily',
      getImageCarousel: 'getImageCarousel',
    }),
    reloadFamily: function(){
      this.loadFamily(this.produto.offer.offer_id).then(function(){
        this.getFamily.forEach(element => {
          this.getImageCarousel({ sku: element.sku, imghash: "t-"+element.imghash }).then(function(image){
            element.image = image;
          }.bind(this));
        });
      }.bind(this));
    }
  }
}
</script>